// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-stiffness/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springStiffnessEN: PageEntry = {
  id: "post.federsteifigkeit",
  locale: "en",
  slug: "spring-stiffness",
  seo: {
    title: "Glossary: Spring stiffness explained simply | Dietz GmbH",
    description: "The spring stiffness, also known as the spring constant, is a measure of the stiffness of a spring. It indicates how much force is required to stretch or compress the spring by one",
  },
  type: "post",
  h1: "Glossary: Spring stiffness explained simply",
  intro: "The spring stiffness, also known as the spring constant, is a measure of the stiffness of a spring. It indicates how much force is required to stretch or compress the spring by one unit. The spring stiffness is measured in Newtons per metre (N/m). A higher spring stiffness means that the spring is stiffer, while a lower stiffness indicates a softer spring. Precise knowledge of spring stiffness is crucial for the design of spring systems in various applications, from vehicle chassis to industrial machinery.",
  blocks: [

  ],
};
